const NEXO_WHATSAPP_NUMBER = '18096872952';

function stripAccents(value = '') {
  return value.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}

function normalizeSearchQuery(value = '') {
  let query = stripAccents(value.toLowerCase()).trim();
  const replacements = [
    [/\b(gomas?|neumaticos?|llantas?)\b/g, 'neumatico'],
    [/\b(aire\s+acondicionado|a\/c|ac automotriz)\b/g, 'aire acondicionado'],
    [/\b(carrocerias?)\b/g, 'carroceria'],
    [/\b(electricos?|electricas?|electricidad)\b/g, 'electrico'],
    [/\b(transmisiones?|caja(?:s)?\s+de\s+cambio)\b/g, 'transmision'],
    [/\b(quimicos?|quimicas?|quimica\s+automotriz)\b/g, 'quimicos'],
    [/\b(miscelaneos?|miscelaneas?|miselaneos?|miselaneas?)\b/g, 'miselaneos']
  ];

  replacements.forEach(([pattern, replacement]) => {
    query = query.replace(pattern, replacement);
  });

  return query.replace(/\s+/g, ' ').trim();
}

function bindSearchNormalization(root = document) {
  root.querySelectorAll('form[action*="/search"]').forEach((form) => {
    if (form.dataset.nexoSearchBound === 'true' || form.hasAttribute('data-nexo-no-normalize')) return;
    form.dataset.nexoSearchBound = 'true';
    form.addEventListener('submit', () => {
      const input = form.querySelector('input[name="q"]');
      if (!input || !input.value.trim()) return;
      input.value = normalizeSearchQuery(input.value);
    });
  });
}

function buildAssistanceMessage(form) {
  const rows = [];
  form.querySelectorAll('[data-nexo-field]').forEach((input) => {
    const value = input.value.trim();
    if (!value) return;
    rows.push(`${input.dataset.label}: ${value}`);
  });

  return [
    'Hola, necesito ayuda para encontrar una pieza.',
    '',
    ...rows,
    '',
    'Enviado desde repuestoseliseo.com.do'
  ].join('\n');
}

function bindVehicleForms(root = document) {
  root.querySelectorAll('[data-nexo-assistance-form]').forEach((form) => {
    if (form.dataset.nexoAssistanceBound === 'true') return;
    form.dataset.nexoAssistanceBound = 'true';

    form.addEventListener('submit', (event) => {
      event.preventDefault();
      if (!form.reportValidity()) return;
      const message = buildAssistanceMessage(form);
      const number = form.dataset.whatsapp || NEXO_WHATSAPP_NUMBER;
      window.open(`https://wa.me/${number}?text=${encodeURIComponent(message)}`, '_blank', 'noopener');
    });

    const emailButton = form.querySelector('[data-nexo-send-email]');
    if (emailButton) {
      emailButton.addEventListener('click', () => {
        if (!form.reportValidity()) return;
        const email = form.dataset.email;
        if (!email) return;
        const subject = 'Solicitud de pieza desde la tienda online';
        const message = buildAssistanceMessage(form);
        window.location.href = `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(message)}`;
      });
    }
  });
}

function rewriteProductLinks(root = document) {
  root.querySelectorAll('a[href*="/products/"]').forEach((link) => {
    if (link.dataset.nexoProductLink === 'true') return;

    const productContainer = link.closest('[data-product-id]');
    const productId = productContainer?.dataset.productId;
    if (!productId) return;

    let url;
    try {
      url = new URL(link.href, window.location.origin);
    } catch (_) {
      return;
    }

    const match = url.pathname.match(/\/products\/([^/?#]+)/i);
    if (!match) return;

    const handle = decodeURIComponent(match[1]);
    const accessibleTitle = link.getAttribute('aria-label')?.trim();
    const visibleTitle = link.textContent?.replace(/\s+/g, ' ').trim();
    const query = accessibleTitle || visibleTitle || handle.replace(/-/g, ' ');

    const target = new URL('/search', window.location.origin);
    target.searchParams.set('type', 'product');
    target.searchParams.set('q', query);
    target.searchParams.set('view', 'producto');
    target.searchParams.set('pid', productId);

    link.href = `${target.pathname}${target.search}`;
    link.dataset.nexoProductLink = 'true';
  });
}

const CHAT_TRANSLATIONS = new Map([
  ['Hi there 👋', '¡Hola! 👋'],
  ['Hi there', '¡Hola!'],
  ['How can I help you?', '¿Cómo podemos ayudarte?'],
  ['Write a response', 'Escribe tu mensaje'],
  ['Send', 'Enviar']
]);

function translateChatText(root = document.body) {
  if (!root) return;
  const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
    acceptNode(node) {
      const parent = node.parentElement;
      if (!parent || ['SCRIPT', 'STYLE', 'NOSCRIPT', 'TEXTAREA'].includes(parent.tagName)) return NodeFilter.FILTER_REJECT;
      return CHAT_TRANSLATIONS.has(node.nodeValue.trim()) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });

  const nodes = [];
  while (walker.nextNode()) nodes.push(walker.currentNode);
  nodes.forEach((node) => {
    const original = node.nodeValue.trim();
    node.nodeValue = node.nodeValue.replace(original, CHAT_TRANSLATIONS.get(original));
  });

  root.querySelectorAll('input[placeholder], textarea[placeholder]').forEach((input) => {
    const translation = CHAT_TRANSLATIONS.get(input.placeholder.trim());
    if (translation) input.placeholder = translation;
  });
}

function bindWhatsappWidgets(root = document) {
  root.querySelectorAll('[data-nexo-whatsapp-widget]').forEach((widget) => {
    if (widget.dataset.nexoWhatsappBound === 'true') return;
    widget.dataset.nexoWhatsappBound = 'true';

    const panel = widget.querySelector('[data-nexo-whatsapp-panel]');
    const toggle = widget.querySelector('[data-nexo-whatsapp-toggle]');
    const close = widget.querySelector('[data-nexo-whatsapp-close]');
    const form = widget.querySelector('[data-nexo-whatsapp-chat-form]');
    const input = form?.querySelector('input');

    const setOpen = (open) => {
      if (!panel || !toggle) return;
      panel.hidden = !open;
      toggle.setAttribute('aria-expanded', String(open));
      if (open) window.setTimeout(() => input?.focus(), 50);
    };

    toggle?.addEventListener('click', () => setOpen(panel?.hidden !== false));
    close?.addEventListener('click', () => setOpen(false));

    form?.addEventListener('submit', (event) => {
      event.preventDefault();
      const message = input?.value.trim();
      if (!message) {
        input?.focus();
        return;
      }
      const number = widget.dataset.whatsapp || NEXO_WHATSAPP_NUMBER;
      window.open(`https://wa.me/${number}?text=${encodeURIComponent(message)}`, '_blank', 'noopener');
    });
  });
}

function initializeNexo(root = document) {
  bindSearchNormalization(root);
  bindVehicleForms(root);
  bindWhatsappWidgets(root);
  rewriteProductLinks(root);
  translateChatText(document.body);
}

document.addEventListener('DOMContentLoaded', () => initializeNexo(document));
document.addEventListener('shopify:section:load', (event) => initializeNexo(event.target));

const observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    mutation.addedNodes.forEach((node) => {
      if (!(node instanceof Element)) return;
      bindSearchNormalization(node);
      bindVehicleForms(node);
      bindWhatsappWidgets(node);
      rewriteProductLinks(node);
      translateChatText(node);
    });
  });
});

if (document.documentElement) {
  observer.observe(document.documentElement, { childList: true, subtree: true });
}
